import axios from "axios";
import Cookies from "js-cookie";

const csrf = () => ({
  headers: { "X-CSRFTOKEN": Cookies.get("csrftoken") },
  withCredentials: true,
});

// Service wrapper for the Free Agent Hub and roster handshake endpoints.
export const LeagueApi = {
  async getMyStatus() {
    const res = await axios.get("/api/league/free-agents/me/", {
      withCredentials: true,
    });
    return res.data;
  },
  async setMyStatus(data) {
    const res = await axios.put("/api/league/free-agents/me/", data, csrf());
    return res.data;
  },
  async listFreeAgents() {
    const res = await axios.get("/api/league/free-agents/", {
      withCredentials: true,
    });
    return res.data;
  },
  async listInvites() {
    const res = await axios.get("/api/league/roster-invites/", {
      withCredentials: true,
    });
    return res.data;
  },
  async advanceInvite(id, action) {
    const res = await axios.post(
      `/api/league/roster-invites/${id}/${action}/`,
      {},
      csrf(),
    );
    return res.data;
  },
  async createSoloTeam() {
    const res = await axios.post("/api/league/solo-team/", {}, csrf());
    return res.data;
  },
  async myChallenges() {
    const res = await axios.get("/api/league/my-challenges/", {
      withCredentials: true,
    });
    return res.data;
  },
  async listSubmissions() {
    const res = await axios.get("/api/league/submissions/", {
      withCredentials: true,
    });
    return res.data;
  },
  async submissionOptions() {
    const res = await axios.get("/api/league/submissions/options/", {
      withCredentials: true,
    });
    return res.data;
  },
  async createSubmission(data) {
    const res = await axios.post("/api/league/submissions/", data, csrf());
    return res.data;
  },
  async updateSubmission(id, data) {
    const res = await axios.put(`/api/league/submissions/${id}/`, data, csrf());
    return res.data;
  },
  async validateSubmission(id) {
    const res = await axios.post(
      `/api/league/submissions/${id}/validate/`,
      {},
      csrf(),
    );
    return res.data;
  },
  async lockSubmission(id) {
    const res = await axios.post(
      `/api/league/submissions/${id}/lock/`,
      {},
      csrf(),
    );
    return res.data;
  },
  async judgingHackathons() {
    const res = await axios.get("/api/league/judging/", {
      withCredentials: true,
    });
    return res.data;
  },
  async judgingBoard(hackathonId) {
    const res = await axios.get(
      `/api/league/judging/?hackathon=${hackathonId}`,
      { withCredentials: true },
    );
    return res.data;
  },
  async submitEvaluation(submission, scores) {
    const res = await axios.post(
      "/api/league/judging/",
      { submission, scores },
      csrf(),
    );
    return res.data;
  },
  async finalizeJudging(hackathon) {
    const res = await axios.post(
      "/api/league/judging/finalize/",
      { hackathon },
      csrf(),
    );
    return res.data;
  },
  async recruitPool(teamId, level) {
    const res = await axios.get(
      `/api/league/recruit/?team=${teamId}&level=${level}`,
      { withCredentials: true },
    );
    return res.data;
  },
  async coMembershipJoin(invite) {
    const res = await axios.post(
      "/api/league/recruit/co_membership/",
      { invite },
      csrf(),
    );
    return res.data;
  },
  async commissionerLog() {
    const res = await axios.get("/api/league/commissioner/", {
      withCredentials: true,
    });
    return res.data;
  },
  async commissionerOverride(kind, data) {
    const res = await axios.post(
      `/api/league/commissioner/${kind}/`,
      data,
      csrf(),
    );
    return res.data;
  },
};
